import posthog from "posthog-js";

/**
 * The browser's PostHog distinct_id, or undefined when PostHog is blocked,
 * not loaded, or throws.
 *
 * Never throws and never returns an empty string: booking submission must
 * not depend on analytics being present (ad blockers, consent opt-out,
 * PostHog failing to initialise). Callers treat undefined as "no id" and
 * omit the field from the payload.
 */
export const getPosthogDistinctId = (): string | undefined => {
  try {
    const id = posthog.get_distinct_id();
    return typeof id === "string" && id.length > 0 ? id : undefined;
  } catch {
    return undefined;
  }
};

/**
 * Spread helper for the submit-4 booking payload: `{ posthog_distinct_id }`
 * when an id exists, otherwise no key at all — so the "PostHog absent" case
 * omits the field cleanly instead of sending null/empty.
 */
export const posthogDistinctIdField = ():
  | { posthog_distinct_id: string }
  | Record<string, never> => {
  const id = getPosthogDistinctId();
  return id === undefined ? {} : { posthog_distinct_id: id };
};
